import { render, staticRenderFns } from "./ProductsCategoriesListDialog.vue?vue&type=template&id=187205fa&scoped=true&v-slot%3Aitems=props&slot-scope=props&"
import script from "./ProductsCategoriesListDialog.vue?vue&type=script&lang=js&"
export * from "./ProductsCategoriesListDialog.vue?vue&type=script&lang=js&"
import style0 from "./ProductsCategoriesListDialog.vue?vue&type=style&index=0&id=187205fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187205fa",
  null
  
)

export default component.exports